import React from "react";
import axios from "axios";
import {isMobileOnly} from "react-device-detect";
import DoubleTemplateComponent from "../../containers/template_page/double_template_component/double_template_component";
import "./c76_convenzioni_b.scss";

class ConvenzioniB extends DoubleTemplateComponent {
    constructor(props) {
        super(props);
        this.requireInternationalization = true;
    }

    showMore = (ep) => {
        axios.get(ep, {}).then((res) => {
            let cards = this.state.data.conventions.concat(res.data.conventions);

            this.setState({
                callMore: true,
                data: {
                    ...this.state.data,
                    ...{conventions: cards, next_page: res.data.next_page},
                },
            });
        });

    };

    internationalComponentRender(allData, t) {
        let filteredCards = allData.conventions;

        return (
            <div id={!isMobileOnly ? "b-convenzioni-grid" : "b-convenzioni-grid-mob"} className="c52-news">
                <div className="container">
                    <div className="row b-convenzioni-card-row">
                        {filteredCards && filteredCards.length > 0 ? (
                            filteredCards.map((card, index) => {

                                let min_discount;
                                let max_discount;

                                if (!card.min_discount) {
                                    min_discount = card.max_discount; 
                                    max_discount = false;
                                } else {
                                    min_discount = card.min_discount;
                                    max_discount = card.max_discount;
                                }

                                return (
                                <div className="col-xl-4 col-md-6" key={index}>
                                    <a href={card.url_card}>
                                        <div className="b-convenzioni-card mx-auto">
                                            <div className="separator"/>
                                            <div className="b-convenzioni-card-category">{card.category.label}</div>
                                            <div className="b-convenzioni-card-sconto">{card.max_discount ?
                                                        <div>{t("C75 Discount label")} : {min_discount}% {max_discount ? `- ${max_discount}%` : null}</div> : null}</div>
                                            <div className="b-convenzioni-card-title">{card.title && card.title}</div>
                                        </div>
                                    </a>
                                </div>
                                )
                            }
                            )
                            ) : (
                            <p className={"not-found"}>{t("C75 no content")}</p>
                        )}
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-12 text-center">
                                {allData.next_page !== "" && filteredCards && filteredCards.length > 0 && (
                                    <button className="b-convenzioni-carica-altro-btn"
                                            onClick={() => this.showMore(allData.next_page)}>{allData.loadmore_label}</button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ConvenzioniB;
